const HamburgerIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 27 27"
      className={className ? className : "w-[27px] h-[27px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M24.04 5.917c0-.598-.486-1.083-1.084-1.083H8.872a1.083 1.083 0 1 0 0 2.166h14.084c.598 0 1.083-.485 1.083-1.083M24.04 13.5c0-.598-.486-1.083-1.084-1.083h-19.5a1.083 1.083 0 1 0 0 2.167h19.5c.598 0 1.083-.485 1.083-1.084M22.956 20a1.083 1.083 0 1 1 0 2.167h-8.667a1.083 1.083 0 1 1 0-2.167z"
      ></path>
    </svg>
  );
};

export default HamburgerIcon;
